var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 102,
    viewBox: "0 0 115 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7196C0 5.76356 5.56482 0 12.7196 0H44.5185V31.7989H76.3175V39.5499C61.6105 43.7235 50.8783 57.2381 50.8783 73.1376C50.8783 85.0622 56.6419 95.3968 65.3866 101.757C64.7903 101.757 64.1941 101.757 63.5979 101.757H12.7196C5.56482 101.757 0 96.1918 0 89.037V12.7196Z",
    fill: "#AEFFD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5195 31.7989V0L76.3185 31.7989H44.5195ZM57.2391 73.1376C57.2391 57.4368 69.9587 44.5185 85.8582 44.5185C101.559 44.5185 114.477 57.4368 114.477 73.1376C114.477 89.037 101.559 101.757 85.8582 101.757C69.9587 101.757 57.2391 89.037 57.2391 73.1376ZM89.0381 60.418C89.0381 58.828 87.4481 57.2381 85.8582 57.2381C84.0695 57.2381 82.6783 58.828 82.6783 60.418V69.9577H73.1386C71.3499 69.9577 69.9587 71.5476 69.9587 73.1376C69.9587 74.9263 71.3499 76.3175 73.1386 76.3175H82.6783V85.8571C82.6783 87.6458 84.0695 89.037 85.8582 89.037C87.4481 89.037 89.0381 87.6458 89.0381 85.8571V76.3175H98.5777C100.168 76.3175 101.758 74.9263 101.758 73.1376C101.758 71.5476 100.168 69.9577 98.5777 69.9577H89.0381V60.418Z",
    fill: "#46EA9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocument);
export default __webpack_public_path__ + "static/media/addDocument.510661214a3fe63645b1c99890376aca.svg";
export { ForwardRef as ReactComponent };